<template>
  <div v-if="category">
    <popup-add-todo ref="popupAddTodo" />
    <vs-row
      ><h1 class="mb-4">{{ headerText }}</h1>

      <vs-button
        radius
        v-if="!isFiltering"
        color="primary"
        type="border"
        icon="add"
        size="small"
        class="ml-3"
        @click="$refs.popupAddTodo.show()"
      ></vs-button>

      <vs-button
        radius
        v-if="!isFiltering"
        color="gray"
        type="border"
        icon="delete"
        size="small"
        style="margin-left: auto !important"
        class=""
        @click="confirmDeleteCategory"
      ></vs-button>
    </vs-row>
    <div class="vx-row mb-6">
      <vs-list>
        <draggable
          :list="todos"
          @start="drag = true"
          :move="checkMove"
          @end="orderChanged"
        >
          <vs-list-item
            v-for="todo in todos"
            :key="todo.id"
            :class="{ hiddenRow: todo.completed && !showCompleted }"
            :title="todo.title"
            :subtitle="parseSubtitle(todo)"
            class="todo-list-item"
          >
            <vs-row vs-type="flex" align="center" vs-align="center">
              <vx-tooltip text="Notifies you in the LIFE app" position="top">
                <feather-icon
                  v-if="todo.notifyMe"
                  icon="SmartphoneIcon"
                  svgClasses="w-5 h-5 mr-6 text-warning"
                />
              </vx-tooltip>
              <vx-tooltip
                text="This todo is flagged as important"
                position="top"
              >
                <feather-icon
                  v-if="todo.flagged"
                  icon="FlagIcon"
                  svgClasses="w-5 h-5 mr-6 text-warning"
                />
              </vx-tooltip>
              <span class="mr-2">{{ todo.categoryName }}</span>
              <feather-icon
                v-if="filter !== ''"
                :icon="parseIcon(todo.categoryIcon)"
                :style="{ 'background-color': todo.categoryColor }"
                class="mr-6 p-2 rounded-full text-white"
                svgClasses="h-4 w-4"
              ></feather-icon>
              <vs-chip
                class="mr-6"
                :color="getColor(todo)"
                v-if="todo.hasDueDate && todo.completed < 1"
                >Due {{ format(todo.startDate) }}</vs-chip
              >
              <feather-icon
                class="cursor-pointer"
                icon="EyeIcon"
                color="success"
                svgClasses="w-5 h-5 hover:text-primary stroke-current"
                @click.stop="$refs.popupAddTodo.showWith(todo)"
              />
            </vs-row>
            <template slot="avatar">
              <vs-checkbox
                @click.native="changeChecked(todo, !todo.completed)"
                v-model="todo.completed"
              ></vs-checkbox>
            </template>
          </vs-list-item>
        </draggable>
      </vs-list>
    </div>
  </div>

  <!-- -->
</template>

<script>
import draggable from "vuedraggable";
import { RRule, RRuleSet, rrulestr } from "rrule";
import moment from "moment";
import _ from "lodash";
import { mapGetters } from "vuex";
import PopupAddTodo from "./PopupAddTodo.vue";
import { format } from "timeago.js";
export default {
  data() {
    return { drag: false, format, moment };
  },
  components: {
    draggable,
    PopupAddTodo,
  },
  computed: {
    ...mapGetters({
      activeVenue: "venues/activeVenue",
      preferredRole: "users/preferredRole",
      categories: "personalTodos/categories",
      category: "personalTodos/category",
      filter: "personalTodos/filter",
      todos: "personalTodos/todos",
      isFiltering: "personalTodos/isFiltering",
      filterName: "personalTodos/filterName",
      showCompleted: "personalTodos/showCompleted",
    }),
    headerText() {
      return this.isFiltering ? this.filterName : this.category.name;
    },
  },
  methods: {
    parseIcon(icon) {
      if (icon.includes("Icon")) return icon;
      else return icon.charAt(0).toUpperCase() + icon.slice(1) + "Icon";
    },
    getColor(todo) {
      const todoDueDate = moment(todo.startDate).valueOf();
      const nowDate = Date.now();
      const isLate = todoDueDate < nowDate;
      if (isLate) {
        return "red";
      }
      return "primary";
    },
    parseSubtitle(todo) {
      const elements = [];
      if (todo.note) elements.push(todo.note);
      if (todo.address) elements.push(todo.address);
      return elements.join(" • ");
    },
    checkMove() {
      return !this.isFiltering;
    },
    confirmDeleteCategory() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Are you sure you want to delete this list?",
        accept: this.deleteCategory,
      });
    },
    async deleteCategory() {
      await this.$store.dispatch("personalTodos/deleteCategory");
    },
    async changeChecked(task, newStatus) {
      const newBool = newStatus ? 1 : 0;
      await this.$store.dispatch("personalTodos/updateTodoCompleted", {
        todoId: task.id,
        categoryId: task.categoryId,
        completed: newBool,
      });
    },
    async orderChanged(e) {
      this.drag = false;

      const oldIndex = e.oldIndex;
      const newIndex = e.newIndex;
      if (this.isFiltering || oldIndex === newIndex) return;
      console.log("Moved from", oldIndex, "to", newIndex);
      await this.$store.dispatch("personalTodos/updateTodoOrder", {
        oldIndex: oldIndex,
        newIndex: newIndex,
      });
    },
  },
  mounted() {},
};
</script>
<style scoped>
.todo-list-item {
  border-bottom: 1px solid #ebe9f1;
  min-height: 3.8rem;
}
.vs-list--item {
  padding-left: 10px;
  padding-right: 15px;
}
.vs-list {
  padding-left: 0;
  padding-right: 0;
}
.hiddenRow {
  display: none;
}
</style>
